import React, { useState, useEffect } from 'react'
import injectWidget from './shared/injectWidget'
import UpdateAccount from '../components/UpdateAccount'
import { updateAccountServiceConfig } from './shared/config'


function UpdateAccountBuild({
  configureTrack,
  services,
  i18n,
  ...rest
}) {
  const [initData, setInitData] = useState({
    initComplete: false,
    username: '',
    nextTimeEmail: '',
    errorMsg: undefined
  })
  const { initUpdateAccount } = services
  
  useEffect(() => {
    initUpdateAccount({
      params: {},
      resolve: response => {
        setInitData({
          initComplete: true,
          username: response.username,
          nextTimeEmail: response.nextTimeEmail
        })
      },
      reject: () => {
        setInitData({
          initComplete: true,
          errorMsg: i18n('passport.error.server.default')
        })
      },
    })
  }, [])

  return (
    initData.initComplete && <UpdateAccount 
      {...rest}
      username={initData.username}
      nextTimeEmail={initData.nextTimeEmail}
      i18n={i18n}
      services={services}
      kcErrorMessage={initData.errorMsg}
    />
  )
}

const UpdateAccountWidget = injectWidget({
  widget: UpdateAccountBuild,
  serviceConfig: updateAccountServiceConfig,
})

export default UpdateAccountWidget